module.exports = __webpack_public_path__ + "img/graph.890d1495.png";